function preload_image(img_url) {
  let img = new Image();
  img.src = img_url;
}
const reves = document.querySelectorAll(".reve-item");
reves &&
  reves.forEach((reve) => {
    const header = reve.querySelector(".reve-item-header");
    const accordeonTrigger = header.querySelector(".reve-item-header-title");

    const content = reve.querySelector(".reve-item-content");
    const footer = reve.querySelector(".reve-item-footer");

    accordeonTrigger.addEventListener("click", () => {
      console.log(content.scrollHeight);
      if (content.classList.contains("open")) {
        content.classList.remove("open");
        footer.classList.remove("open");

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        }
      } else {
        const activeElements = Array.from(document.querySelectorAll(".open"));
        activeElements.forEach((activeElement) => {
          const activeText =
            activeElement.classList.contains("reve-item-content");
          if (activeText) {
            const theActiveText = activeElement;
            if (theActiveText.style.maxHeight) {
              theActiveText.style.maxHeight = null;
            }
          }
          activeElement.classList.remove("open");
        });
        const reve_image = content.querySelector("img");
        reve_image && preload_image(reve_image.src);
        content.classList.add("open");
        footer.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
